import {findLast,split,filter,sortBy} from 'lodash'

class Routes {
    constructor(){}
    recursion(routeConfig){
        if(routeConfig && routeConfig.length >0) {
            routeConfig.map(item =>{
                if(item.children && item.children.length > 0) {
                item.children.map(val =>{
                    if(val.path && val.path != '/') val.path = `${item.path}${val.path}` ;
                    return val;
                })
                item.children = this.recursion(item.children);
                const rc = findLast(item.children, val =>{
                    return !val.path || val.path === '/'
                })
                if(rc && rc.redirect) {
                    item.redirect = rc.redirect;
                }
                
                }
                return item
            })
        }
        return routeConfig;
    }
}

 class Wrapper {
    constructor(){
        this.newRoutes = new Routes();
    }
    routes(routeConfig){
        return this.newRoutes.recursion(routeConfig);
    }
    store(Store){
        const context = require.context('@',true,/[\w]+-store.js$/);
        const modMap = new Map()
        context.keys().forEach(fileName =>{
            const sp =  split(fileName, '/');
            const sf = filter(sp,(o,i,a) => {
               return i > 0 && i < a.length -1;
            });
            const store = context(fileName)
            modMap.set(sf,store.default)
        })
        const mapSort = new Map(sortBy([...modMap.entries()],o => o[0].length));
        mapSort.forEach((value, key)=>{
            Store.registerModule(key,value)
        })
    }
}


export const wrapper = new Wrapper();
